import { CodeBook } from "@king-ict/eupisi-ui/models/Common/CodeBook";

import { HierarchicalCodeBook } from "../Shared/HierarchicalCodeBook";

export interface HouseNumberInstitutionSearch {
  countyList: number[];
  municipalityList: HierarchicalCodeBook[];
  townList: HierarchicalCodeBook[];
  streetList: HierarchicalCodeBook[];
  houseNumberFrom?: number;
  houseNumberTo?: number;
  houseNumberSelector?: number;
  institution?: CodeBook;
  assignmentStatus?: HouseNumberInstitutionAssignmentStatus;
}

export enum HouseNumberInstitutionAssignmentStatus {
  /// <summary>
  /// nedodijeljene adrese
  /// </summary>
  Unassigned = 1,
  /// <summary>
  /// dodijeljene adrese
  /// </summary>
  Assigned = 2,
}
